export default "/images/039d9e4780fd78298bca6caffbfe9806.avif";